export const setConfig = (zwibbler, { name, value }) => {
  return zwibbler.setConfig(name, value);
};

export const getConfig = (zwibbler, name) => {
  return zwibbler.getConfig(name);
};



// WEBPACK FOOTER //
// ./src/components/Zwibbler/ExternalApi/handlers/Config.js